// reloads Angular and hands responsibility of navigating to MVC
export function reloadApp(environment: {
  production: boolean;
  apiUrl: string;
}): boolean {
  window.location.href = environment.apiUrl;
  return true;
}
